<template>
  <section class="flex level-1" v-touch:swipe.right="swipeRightHandler">   

    <!-- //TITLE MOBILE -->
    <div class="mobile"  :class="{isMobile:isMobile}">
      <div class="link">
        <button class="bt btn-back" @click="goBack()">
          <font-awesome-icon :icon="['far', 'angle-left']"/>
        </button>
        <h2>Excursions</h2>
      </div>
      <div class="sep"></div>
    </div>
    <!-- //TITLE MOBILE -->

    <!-- CONTENT-->
    <div class="block__excursion content__excursion">

      <!-- //TITLE MOBILE -->
      <div class="header entete mobile">     
        <div class="select__wrapper">
          <font-awesome-icon :icon="['far', 'chevron-down']" />

          <b-form-select v-model="selected" :options="options" class="select" @change="changed">
          </b-form-select>

            <div class="target"  :class="target" v-if="target=='progress'"> {{general.targetProgress}} </div>            
            <div class="target"  :class="target" v-else-if="target=='done'"> {{general.targetDone}} </div>            
            <div v-else-if="target == undefined"></div>            
        </div>
      </div> 
      <!-- //TITLE MOBILE -->

      <!-- PART MIDDLE -->
      <div class="column-middle">

        <div class="header entete desktop">
          <PuSkeleton :loading="isLoading" :count="1" width='140px'>                          
            <p>
              Excursions
            </p>
          </PuSkeleton>
          
          <div class="select__wrapper">
            <font-awesome-icon :icon="['far', 'chevron-down']" />

            <b-form-select v-model="selected" :options="options" class="select" @change="changed">
            </b-form-select>

              <div class="target"  :class="target" v-if="target=='progress'"> {{general.targetProgress}} </div>            
              <div class="target"  :class="target" v-else-if="target=='done'"> {{general.targetDone}} </div>            
              <div v-else-if="target==undefined "></div>            
          </div>

        </div>
        
        <div class="sep desktop"></div>

        <section class="block__blog">

          <div class="header">
            <p class="title">
              <PuSkeleton :loading="isLoading" :count="1" width='140px'>              
                {{content.title}}
              </PuSkeleton>
            </p>
            <div class="date">
              <div class="end">
                <font-awesome-icon :icon="['fas', 'calendar-exclamation']"/>
                <span>{{content.dateEnd}}</span>
              </div>
              <span class="separator">|</span>
              <div class="start">
                <PuSkeleton :loading="isLoading" :count="1" width='40px'>
                  {{content.dateStart}}
                </PuSkeleton>
              </div>
            </div>
          </div>

          <PuSkeleton :loading="isLoading" :count="1" width='100%' height="200px">
            <b-img :src="content.src" class="" fluid alt="placeholder"></b-img>
          </PuSkeleton>

          <PuSkeleton :loading="isLoading" :count="10" width='100%'>
            <div class="content_desc" v-html="content.content">
            </div>
          </PuSkeleton>

        </section>
      </div>
      <!-- PART MIDDLE -->

      <!-- PART RIGHT -->
      <div class="col-right column-right borderLeft">
        <tabsSideBar :lists="lists"/>
      </div>
      <!-- PART RIGHT -->
    </div>
    <!-- CONTENT-->

  </section>
</template>


<script>
import { mapGetters } from 'vuex'
import tabsSideBar from '../../../module/tabs/TabsSidebar'
import utils from '../../../Utils'


export default {
  name:"challengeExcursions",
    components:{ 
      tabsSideBar,
    }, 
    computed: {
      ...mapGetters([
        'getBlog',
        'getLists',
        'getGeneral',
      ])
    },
    data () {
      return {
        content:"",
        general:"",
        lists:"",
        selected: null,
        target : null,
        isLoading:true,
        options: [
            { value: null, text: 'Please select an option', target:"progress" },
            { value: 'a', text: '1ère excursion - Taux AEL', target:"done" },
            { value: 'b', text: 'Selected Option', target:"progress" },
            { value: { C: '3PO' }, text: 'This is an option with object value' },
          ]         
      }
    },
    created (){
      this.content = this.getBlog;
      this.lists = this.getLists;
      this.general = this.getGeneral;
      this.isMobile = utils.isMobile();
      setTimeout(() => {
        this.isLoading = false;
        // this.majData();
      },2000);      
    },    
    mounted(){
      this.changed();
    },
    methods : {      
      changed(){
        const report = this.options.find(option => option.value === this.selected);  
        this.target = report.target;
        // console.log(this.target);
        // return report.target;
      },
      goBack() {
        this.$store.dispatch('goBack')
        this.$router.push({name: "challengesHome"});  
      },
      swipeRightHandler () {
          this.goBack();
      },              
    }
};
</script>
